import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import ProtectedLogin from "@/components/auth/ProtectedLogin";
import ProtectedRouter from "@/components/auth/ProtectedRouter";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Logout from "@/pages/Logout";
import PhieuThayDau from "@/pages/PhieuThayDau";
import Manager from "@/pages/Manager";
import SuperVoucher from "@/pages/SuperVoucher";

const routes = createBrowserRouter([
  {
    path: "/",
    children: [
      { element: <Navigate to="/Login" />, index: true },
      {
        path: "/Login",
        element: <ProtectedLogin props={<Login />} type={""} key={""} />,
      },
    ],
  },
  {
    path: "/Manage/*",
    element: <ProtectedRouter />,
    children: [
      { path: "", element: <Manager /> },
      { path: "PhieuThayDau", element: <PhieuThayDau /> },
      { path: "SuperVoucher", element: <SuperVoucher /> },
      {
        path: "ChangePassword",
        element: <ChangePassword />,
      },
      {
        path: "logout",
        element: <Logout />,
      },
    ],
  },
]);

const MainRouter = () => {
  return <RouterProvider router={routes} />;
};

export default MainRouter;
